import './App.css';
import { useMsal } from "@azure/msal-react";
import { Routes, Route, BrowserRouter } from 'react-router-dom';
import VideoListing from './Components/Videos/VideoListing';
import VideoListingFull from './Components/Videos/VideoListingFull';
import DocumentListing from './Components/Documents/DocumentListing';
import ViewStream from './Components/Videos/View/ViewStream';
import ViewDocument from './Components/Documents/View/ViewDocument';
import Home from './Components/Home/Home';
import AdditionalDevelopment from './Components/Wallet/AdditionalDevelopmentUI';
import DocumentListingFull from './Components/Documents/DocumentListingFull';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import SideMenu from './Components/SideMenu';
import AppNavbar from './Components/AppNavbar';
import Box from '@mui/material/Box';
import Header from './Components/Header';
import { HistoryProvider } from './Context/HistoryContext';
import { UserProvider } from './Context/UserContext';
import { APIProvider } from './Context/APIContext';
import { loginRequest } from "../src/Auth/authConfig";
import { useMsalAuthentication } from "@azure/msal-react";
import { InteractionType } from "@azure/msal-browser";
import CircularProgress from '@mui/material/CircularProgress';
import { VideoListingFullPageType, VideoListingPageType } from './Models/VideoListingPageType';
import { DocumentListingFullPageType, DocumentListingPageType } from './Models/DocumentListingPageType';

const theme = createTheme({
  typography: {
    fontFamily: 'Inter, sans-serif',
    fontWeightRegular: 400,
    fontWeightMedium: 500,
    fontWeightBold: 700,
    h1: {
      fontSize: '3rem',
      fontWeight: 700,
      letterSpacing: '0.5px',
      marginBottom: '1.5rem',
    },
    h2: {
      fontSize: '2rem',
      fontWeight: 600,
      letterSpacing: '0.5px',
      marginBottom: '1.5rem',
    },
    h6: {
      fontSize: '1.25rem', // 20px
      fontWeight: 400,
    },
  },
  palette: {
    primary: {
      main: '#3D9BE9',
    },
    secondary: {
      main: '#9c27b0',
    },
    text: {
      primary: '#333',
      secondary: '#666',
    },
  },
  spacing: 8,
},
);


const App = () => {
  const { result, error } = useMsalAuthentication(InteractionType.Redirect, loginRequest);
  const { accounts } = useMsal();
  const isAuthenticated = accounts.length > 0;

  if (error) {
    console.error(error);
    return <div>Error initializing authentication</div>;
  }

  if (!result && !isAuthenticated) {
    return (
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh',
          bgcolor: 'background.default',
        }}
      >
        <CircularProgress sx={{ color: '#3D9BE9' }} size={80} />
      </Box>
    )
  }

  return (
    <ThemeProvider theme={theme}>
      <div>
          <BrowserRouter>
            <APIProvider>
              <HistoryProvider>
                <UserProvider>
                  <Box sx={{ display: 'flex' }}>
                    <SideMenu />
                    <AppNavbar />
                    <Box
                      component="main"
                      sx={{
                        mt: '20px',
                        overflow: 'hidden',
                        width: '100%'
                      }}
                    >
                      <Header />
                      <Routes>
                        <Route path="/videos/staff" element={<VideoListing type={VideoListingPageType.Staff} categoryIds={[1,3,4,18]} />} />
                        <Route path="/videos/students" element={<VideoListing type={VideoListingPageType.Students} categoryIds={[15,16,17,19,5,7,12,13,14]}/>} />
                        <Route path="/videos/saved" element={<VideoListingFull type={VideoListingFullPageType.Saved} />} />
                        <Route path="/videos/:categoryId" element={<VideoListingFull type={VideoListingFullPageType.Category} />} />
                        <Route path="/stream/:streamId" element={<ViewStream />} />
                        <Route path="/guides/staff" element={<DocumentListing type={DocumentListingPageType.Staff} categoryIds={[8]}/>} />
                        <Route path="/guides/students" element={<DocumentListing type={DocumentListingPageType.Students} categoryIds={[9,10,11]}/>} />
                        <Route path="/guides/saved" element={<DocumentListingFull type={DocumentListingFullPageType.Saved} />} />
                        <Route path="/guides/:categoryId" element={<DocumentListingFull type={DocumentListingFullPageType.Category}/>} />
                        <Route path="/document/:documentId" element={<ViewDocument />} />
                        <Route path="/additional-development" element={<AdditionalDevelopment />} />
                        <Route path="/" element={<Home />} />
                      </Routes>
                    </Box>
                  </Box>
                </UserProvider>
              </HistoryProvider>
            </APIProvider>
          </BrowserRouter>
      </div>
    </ThemeProvider>
  );
};

export default App;